import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { formatUrl } from "../../util/format-url";
import {
  MiniAquaSquare,
  MiniGreenTriangle,
  MiniOrangeTriangle,
  MiniYellowSquare,
  PurpleDiamond,
  PurpleTriangle,
} from "../../assets/shapes";

export default function SolutionsView(props: any) {
  const { navList, pages } = props;
  const [solutions, setSolutions] = useState([]);
  useEffect(() => {
    if (navList) {
      var tempSolutions: any = [];
      pages.forEach((page: any) => {
        if (page.group === "Solutions") {
          var tempObject: any = page;
          var tempDiv: HTMLElement = document.createElement("div");
          tempDiv.innerHTML = page.content;
          //console.log("tempDiv", tempDiv);
          var tempImg: HTMLElement = tempDiv.getElementsByTagName("img")[0];
          var tempTxt: HTMLElement = tempDiv.getElementsByTagName("p")[1];
          //console.log("tempImg", tempImg);
          tempObject["img"] = tempImg ? tempImg.outerHTML : "";
          tempObject["shortDescr"] = tempTxt ? tempTxt.outerHTML : "";
          tempSolutions.push(tempObject);
        }
      });
      setSolutions(tempSolutions);
    }
    //console.log("tempSolutions", tempSolutions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //console.log("solutions", solutions, "pages", pages);
  return (
    <div className="custom-website-wrap">
      <div className="custom-website-header">
        <div className="custom-website-header-title">
          Build AI Applications Faster with Solutions
        </div>
        <div className="custom-website-header-subtitle">
          Hit the ground running with pre-built solutions
        </div>
        {
          <>
            <PurpleDiamond />
            <MiniOrangeTriangle />
            <PurpleTriangle />
            <MiniAquaSquare />
            <MiniYellowSquare />
            {/* <BlueCircle /> */}
            <MiniGreenTriangle />
          </>
        }
      </div>
      <div className="custom-website-body">
        <div className="custom-website-body-inner">
          <div className="custom-website-body-inner-section">
            {solutions &&
              solutions.map((solution: any) => (
                <Link
                  className="custom-website-body-card solution"
                  to={`/solutions/${formatUrl(solution.name)}`}
                >
                  <div className="custom-website-body-card-img">
                    {solution["img"] && parse(solution["img"])}
                  </div>
                  <div className="custom-website-body-card-name">
                    {solution.name}
                  </div>
                  <div className="custom-website-body-card-descr">
                    {solution["shortDescr"] && parse(solution["shortDescr"])}
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>
      <div className="custom-website-footer"></div>
    </div>
  );
}
